import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CaseStudies = () => {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/case-studies/`)
      .then((res) => setCases(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <div className="bg-slate-900 text-white pt-36 pb-20 relative">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1600&q=80')] bg-cover bg-center opacity-20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <span className="text-gold font-bold uppercase tracking-widest text-sm mb-2 block">Proven Results</span>
          <h1 className="text-5xl font-display font-bold uppercase tracking-wide mb-4">Case Studies</h1>
          <p className="text-xl text-gray-300 max-w-2xl font-light">
            Real outcomes from integrated execution, predictive maintenance and regulatory expertise.
          </p>
        </div>
      </div>

      <main className="flex-grow py-20 bg-gray-50" data-testid="casestudies-list">
        <div className="container mx-auto px-4">
          {loading ? (
            <p className="text-center text-gray-500">Loading case studies…</p>
          ) : cases.length === 0 ? (
            <p className="text-center text-gray-500">No case studies yet.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {cases.map((cs) => (
                <Link
                  to={`/case-studies/${cs.id}`}
                  key={cs.id}
                  data-testid="casestudy-card"
                  className="group bg-white border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col"
                >
                  <div className="h-48 overflow-hidden relative">
                    <div className="absolute top-3 left-3 z-10 bg-gold text-slate-900 text-xs font-bold uppercase tracking-wider px-2 py-1">{cs.industry}</div>
                    <img src={cs.image} alt={cs.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                  </div>
                  <div className="p-6 flex flex-col flex-grow">
                    <h3 className="text-lg font-display font-bold text-foreground mb-3 group-hover:text-primary transition-colors">{cs.title}</h3>
                    <p className="text-sm text-gray-500 leading-relaxed mb-4 flex-grow">{cs.summary}</p>
                    <span className="text-primary text-sm font-bold uppercase tracking-wider inline-flex items-center gap-2">
                      View Case <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CaseStudies;
